<template>
  <v-container fluid>
    <v-expansion-panels focusable fluid v-if="chek">
      <v-expansion-panel fluid v-for="i in items" :key="i.title">
        <v-expansion-panel-header color="#F1F4FB" class="ma-0">{{i.title}}</v-expansion-panel-header>
        <v-expansion-panel-content color="#F1F4FB">
          <v-row v-for="item in label" :key="item.model">
            <v-col cols="3" class="pr-0">{{item.title}}</v-col>
            <v-col class="px-0">{{i[item.model]}}</v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    <div v-else>
      <v-row class="ma-0">
        <v-col align="center">
          <p class="head">Данных нет</p>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    items: [],
    label: [
      { title: "Краткое описание", model: "text" },
      { title: "Зарплата", model: "Opl" },
      { title: "Сроки", model: "Sr" },
      { title: "Номер для связи", model: "Nom" },
      { title: "Описание", model: "Opis" },
    ],
  }),
  created() {
    this.items = this.$ls.get("vaks");
  },
  computed: {
    chek() {
      if (this.$ls.get("vaks") != undefined) {
        return true;
      } else {
        return false;
      }
    },
  },
};
</script>